export default __webpack_public_path__ + "static/media/Investment.6a110fc85bb6b57b68136d68424680bf.svg";